var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var Wrapper = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var left = _a.left, top = _a.top;
    return "\n    position: absolute;\n    left: ".concat(left, "px;\n    top: ").concat(top, "px;\n    color: white;\n  ");
});
var Comment = function (_a) {
    var left = _a.left, top = _a.top, children = _a.children;
    return (React.createElement(Wrapper, { left: left, top: top }, children));
};
export default Comment;
var templateObject_1;
